import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HomeComponent } from './components/home/home.component';
import { DashboardComponent} from './components/dashboard/dashboard.component';
import { NavbarComponent } from './components/shared/navbar/navbar.component';
import { LoginComponent } from './components/login/login.component';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { RecuperarClaveComponent } from './components/recuperar-clave/recuperar-clave.component';
import { CambioClaveComponent } from './components/cambio-clave/cambio-clave.component';
import { BlockCopyPasteDirective } from './components/blockCopyPasteDirective';
import { OnlyNumber } from './components/onlyNumberDirective';
import { LoadingComponent } from './components/login/loading';

@NgModule({
  declarations: [
    HomeComponent,
    DashboardComponent,
    NavbarComponent,
    LoginComponent,
    RecuperarClaveComponent,
    CambioClaveComponent,
    BlockCopyPasteDirective,
    OnlyNumber,
    LoadingComponent
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule
  ],
  schemas: [ CUSTOM_ELEMENTS_SCHEMA ]
})
export class HomeModule { }
